
    export default 
    {
    "duplicate_order_confirm": {
        "dec1": "Wir haben festgestellt, dass Sie bereits eine Bestellung aufgegeben haben",
        "dec2": "bei AliExpress eingestellt haben. Möchten Sie sie trotzdem erneut bei AliExpress aufgeben? Dadurch können doppelte Bestellungen entstehen.",
        "input_confirm": "Geben Sie BESTÄTIGEN ein, um die Bestellungen an AliExpress zu übermitteln."
    }
}